import { IonRouterOutlet } from '@ionic/react'
import React from 'react'
import { Route, RouteComponentProps } from 'react-router-dom'

const EigenheimRouter: React.FC<RouteComponentProps> = ({match}) => {
  return (
    <IonRouterOutlet>
      <Route path={`${match.url}`} render={() => <div>empty auth!</div>} exact={true} />
    </IonRouterOutlet>
  )
}

export default EigenheimRouter
